export default __webpack_public_path__ + "static/media/gallery_04.3e620d8d.jpg";